export function buildWhitelistedNumberPlate ({ id, number_plate: numberPlate, id_wallet: walletId }) {
    return {
        id,
        numberPlate,
        walletId,
    }
}
